module.exports = __webpack_public_path__ + "img/zs4.a1ecd4b9.jpg";